/**
 * Dockly-Logo.
 *
 * Die vier SVG-Dateien unter `/brand/` sind die Originale aus dem Markenpaket,
 * byte-gleich übernommen. Sie werden bewusst als Bild eingebunden und nicht
 * inline gerendert: Inline könnten Umgebungsstile `fill` überschreiben — und
 * das Handbuch verbietet Farbänderungen ausdrücklich.
 *
 * Hell und dunkel wechseln deshalb nicht die Farbe, sondern die **Datei**:
 * auf hellem Grund die positive Fassung, auf dunklem die amtliche Negativ-
 * Fassung. Der Wechsel läuft rein über CSS (siehe `index.css`, Klassen
 * `brand-hell` / `brand-dunkel`), damit er ohne JavaScript und ohne Flackern
 * beim ersten Rendern funktioniert.
 *
 * Nicht verzerren: Es wird nur die Höhe gesetzt, die Breite folgt.
 */
export interface DocklyLogoProps {
  /** `wordmark` = Schriftzug mit Marke, `mark` = nur die Bildmarke. */
  variant?: 'wordmark' | 'mark';
  /** Höhe in Pixeln. Die Breite ergibt sich aus dem Seitenverhältnis. */
  height?: number;
  className?: string;
}

/** Handbuch: Mindestgröße digital 25 px. */
export const MIN_HOEHE_PX = 25;

export function DocklyLogo({ variant = 'wordmark', height = 32, className = '' }: DocklyLogoProps) {
  const basis = variant === 'wordmark' ? 'dockly-wortmarke' : 'dockly-bildmarke';
  const beschriftung = 'Dockly';

  // Unter der Mindestgröße wird die Marke unleserlich — dann lieber größer
  // zeichnen als die Regel verletzen.
  const hoehe = Math.max(height, MIN_HOEHE_PX);

  return (
    <span className={`inline-flex items-center ${className}`.trim()}>
      <img
        src={`/brand/${basis}.svg`}
        alt={beschriftung}
        height={hoehe}
        style={{ height: hoehe, width: 'auto' }}
        className="brand-hell"
      />
      {/* Die Negativ-Fassung liegt daneben und wird per CSS getauscht.
          `aria-hidden`, damit die Marke nicht doppelt vorgelesen wird. */}
      <img
        src={`/brand/${basis}-negativ.svg`}
        alt=""
        aria-hidden="true"
        height={hoehe}
        style={{ height: hoehe, width: 'auto' }}
        className="brand-dunkel"
      />
    </span>
  );
}

export default DocklyLogo;
